// extracted by mini-css-extract-plugin
export default {"leftAddon":"leftAddon__sqJav"};